// Copyright Epic Games, Inc. All Rights Reserved.

import React, { useEffect, useRef, useState } from "react";
import {
    Config,
    AllSettings,
    PixelStreaming,
} from "@epicgames-ps/lib-pixelstreamingfrontend-ue5.4";

export const Wrapper = ({ initialSettings}) => {
    const videoParent = useRef(null);
    const [pixelStreaming, setPixelStreaming] = useState();
    const [clickToPlayVisible, setClickToPlayVisible] = useState(false);

    useEffect(() => {
        if (videoParent.current) {
            
            const config = new Config({ initialSettings });
            const streaming = new PixelStreaming(config, {
                videoElementParent: videoParent.current,
            });

            streaming.addEventListener("playStreamRejected", () => {
                setClickToPlayVisible(true);
            });

            setPixelStreaming(streaming);

            const applyStylesToVideos = () => {
                if (videoParent.current) {
                    const videos = videoParent.current.querySelectorAll('video');

                    // Option 1: Target by index (first video)
                    if (videos.length > 0) {
                        const targetVideo = videos[1]; // Target the first video
                        targetVideo.style.height = "10%";
                        targetVideo.style.position = "relative";
                    }

                    // Option 2: Alternative - add a class or data attribute to identify the video
                    // videos.forEach(video => {
                    //     if (video.classList.contains('main-video') || video.dataset.role === 'main') {
                    //         video.style.width = "40vw";
                    //         video.style.height = "10%";
                    //         video.style.position = "relative";
                    //     }
                    // });
                }
            };

            const styleTimeout = setTimeout(applyStylesToVideos, 500);

            const observer = new MutationObserver(() => {
                if (videoParent.current) {
                    applyStylesToVideos();
                }
            });

            if (videoParent.current) {
                observer.observe(videoParent.current, { childList: true, subtree: true });
            }

            return () => {
                clearTimeout(styleTimeout);
                observer.disconnect();
                try {
                    streaming.disconnect();
                } catch { }
            };
        }
    }, []);

    return (
        <>
            <div
               
            >
                <div
                  
                    ref={videoParent}
                />
                {clickToPlayVisible && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                             width: "max-content"
                        }}
                        onClick={() => {
                            pixelStreaming?.play();
                            setClickToPlayVisible(false);
                        }}
                    >
                        <div>Click to play</div>
                    </div>
                )}
            </div>
        </>
    );
};
